/* Scratch card popup: 1) scratch  2) email to claim  3) code */
(function () {
  const pop = document.querySelector('[data-scratch-pop]');
  if (!pop) return;

  const KEY = pop.dataset.key || 'pawlumi_scratch';
  const delay = parseInt(pop.dataset.delay || '8', 10) * 1000;
  const force = pop.hasAttribute('data-preview');
  const store = {
    get() {
      try { return localStorage.getItem(KEY); } catch (e) { return null; }
    },
    set(value) {
      try { localStorage.setItem(KEY, value); } catch (e) { /* storage blocked */ }
    },
  };

  let shown = false;
  let lastFocus = null;
  let scratchReady = false;

  const showStep = (name) => {
    pop.querySelectorAll('[data-scratch-step]').forEach((step) => {
      step.hidden = step.dataset.scratchStep !== name;
    });
  };

  const focusables = () =>
    [...pop.querySelectorAll('button, a[href], input, canvas[tabindex]')].filter(
      (el) => !el.disabled && el.offsetParent !== null
    );

  function open() {
    if (shown || (!force && store.get())) return;
    // Never cover an open drawer or another modal.
    if (document.querySelector('.drawer.is-open, details[open] > .drawer, .modal.is-open')) {
      setTimeout(open, 4000);
      return;
    }
    shown = true;
    lastFocus = document.activeElement;
    pop.hidden = false;
    if (store.get() === 'subscribed') {
      showStep('code');
    } else {
      showStep('scratch');
      if (!scratchReady) {
        scratchReady = true;
        requestAnimationFrame(initScratch);
      }
    }
    // Focus the dialog itself; Tab then reaches the scratch card, which also scratches with Enter.
    pop.querySelector('.scratch-pop__card').focus({ preventScroll: true });
  }

  function close(remember) {
    pop.hidden = true;
    if (remember && !store.get()) store.set(remember);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  if (force) open();
  else setTimeout(open, delay);

  // Exit intent on desktop.
  document.addEventListener('mouseout', (e) => {
    if (!e.relatedTarget && e.clientY < 8) open();
  });

  pop.addEventListener('click', (e) => {
    if (e.target === pop) close('dismissed');
  });

  document.addEventListener('keydown', (e) => {
    if (pop.hidden) return;
    if (e.key === 'Escape') {
      close('dismissed');
      return;
    }
    if (e.key === 'Tab') {
      const items = focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (!pop.contains(active) || active.classList.contains('scratch-pop__card')) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  pop.querySelectorAll('[data-scratch-close]').forEach((btn) => {
    btn.addEventListener('click', () => close('dismissed'));
  });

  function initScratch() {
    const area = pop.querySelector('.scratch-pop__card-area');
    const canvas = area.querySelector('canvas');
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const w = area.clientWidth;
    const h = area.clientHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.scale(dpr, dpr);

    const styles = getComputedStyle(pop.querySelector('.scratch-pop__title'));
    const fontFamily = styles.fontFamily || 'sans-serif';

    const paint = () => {
      const g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#b9b2aa');
      g.addColorStop(0.5, '#e9e3dc');
      g.addColorStop(1, '#aca49b');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(17, 17, 17, 0.06)';
      for (let i = 0; i < 260; i++) ctx.fillRect(Math.random() * w, Math.random() * h, 2, 2);
      ctx.fillStyle = '#111111';
      ctx.textAlign = 'center';
      ctx.font = `500 26px ${fontFamily}`;
      ctx.fillText(canvas.dataset.coverText || 'Scratch here', w / 2, h / 2);
      ctx.font = `400 14px ${fontFamily}`;
      ctx.fillText(canvas.dataset.coverHint || '', w / 2, h / 2 + 24);
      ctx.globalCompositeOperation = 'destination-out';
    };

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint);
    else paint();

    let down = false;
    let last = null;
    let done = false;
    let strokes = 0;

    const pos = (e) => {
      const r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    };

    const check = () => {
      const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let clear = 0;
      let total = 0;
      for (let i = 3; i < data.length; i += 64) {
        total++;
        if (data[i] === 0) clear++;
      }
      if (clear / total > 0.45) reveal();
    };

    const draw = (p) => {
      ctx.lineWidth = 42;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo((last || p).x, (last || p).y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      last = p;
      if (++strokes % 12 === 0) check();
    };

    function reveal() {
      if (done) return;
      done = true;
      canvas.classList.add('is-done');
      canvas.setAttribute('tabindex', '-1');
      const hint = pop.querySelector('[data-scratch-hint]');
      if (hint) hint.hidden = true;
      setTimeout(() => {
        const claim = pop.querySelector('[data-scratch-claim]');
        if (claim) claim.hidden = false;
        const email = pop.querySelector('input[type=email]');
        if (email) email.focus({ preventScroll: true });
      }, 450);
    }

    canvas.addEventListener('pointerdown', (e) => {
      down = true;
      last = null;
      canvas.setPointerCapture(e.pointerId);
      draw(pos(e));
    });
    canvas.addEventListener('pointermove', (e) => {
      if (down) draw(pos(e));
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) =>
      canvas.addEventListener(type, () => {
        down = false;
        last = null;
      })
    );
    canvas.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        reveal();
      }
    });
  }

  const form = pop.querySelector('form');
  const error = pop.querySelector('[data-scratch-error]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type=email]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value || '')) {
        error.hidden = false;
        error.textContent = 'Enter a valid email to claim your discount.';
        email.setAttribute('aria-invalid', 'true');
        email.focus();
        return;
      }
      error.hidden = true;
      email.removeAttribute('aria-invalid');
      const button = form.querySelector('button[type=submit]');
      button.disabled = true;
      button.textContent = 'Unlocking your code…';
      const finish = () => {
        store.set('subscribed');
        showStep('code');
        const apply = pop.querySelector('[data-scratch-step="code"] a');
        if (apply) apply.focus({ preventScroll: true });
      };
      const action = form.getAttribute('action');
      if (!action) {
        finish();
        return;
      }
      // Shopify customer form: saves the email as a subscriber with the form's tags.
      fetch(action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .catch(() => {})
        .then(finish);
    });
  }

  const copy = pop.querySelector('[data-scratch-copy]');
  if (copy) {
    copy.addEventListener('click', () => {
      const code = copy.dataset.code;
      const done = () => {
        copy.textContent = 'Copied';
      };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, () => (copy.textContent = code));
      else copy.textContent = code;
    });
  }
})();
